import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { inject } from '@angular/core';
import { routerSegments } from '@consts/routes';
import { UserModel } from '@models/user.model';
import { map } from 'rxjs/operators';
import { filter, Observable } from 'rxjs';
import { UserSelectors } from '@states/user/user.selector-types';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { UserState } from '@states/user/user.reducer';

export const operatorRoleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const storeService: Store<AppState> = inject(Store<AppState>);
  const selectUserProfile$: Observable<UserState> = storeService.select(UserSelectors.selectUser);

  if (!authenticationService.isLoggedIn()) {
    return router.createUrlTree([routerSegments.auth, routerSegments.login]);
  }

  return selectUserProfile$
    .pipe(
      filter(state => !!state.isProfileLoaded),
      map(user => {
        if (!user || !user.roles) {
          return router.createUrlTree([routerSegments.auth, routerSegments.login]);
        }
        if (user.roles.includes(UserModel.Role.OPERATOR)) {
          return true;
        } else if (user.roles.includes(UserModel.Role.USER)) {
          return router.createUrlTree([UserModel.defaultRoutesForRole[UserModel.Role.OPERATOR]]);
        } else {
          return router.createUrlTree([UserModel.defaultRoutesForRole[UserModel.Role.DEVELOPER]]);
        }
      }),
    );
};
